import { render, staticRenderFns } from "./PrmTodoList.vue?vue&type=template&id=13580922&"
import script from "./PrmTodoList.vue?vue&type=script&lang=js&"
export * from "./PrmTodoList.vue?vue&type=script&lang=js&"
import style0 from "./PrmTodoList.vue?vue&type=style&index=0&id=13580922&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports